//store
import { store } from '../../store/react';
//language
import {
  getSessionExpired,
  setSessionExpired,
} from '../storageService/GlobalData';
//constants
import { logoutRequested } from '../../store/actions/authentication';
import PbHttpCodes from '../../constants/PbHttpCodes';
import { getLocale } from '../storageService/GlobalData';
import localization from '../../localization/i18n';
import AlertService from '../AlertService';

export function checkSessionExpired(error) {
  let isSessionExpired = getSessionExpired();
  const { isLogin } = store.getState().authentication;

  if (!isSessionExpired && isLogin) {
    if (
      error &&
      error.config &&
      error.config.url.indexOf('user/logout') === -1 &&
      error.data &&
      (error.data.response.code === PbHttpCodes.Error_USER_LOGGED_OUT_ALREADY ||
        error.data.response.code === PbHttpCodes.Error_UNABLE_TO_AUTHENTICATE ||
        error.data.response.code === PbHttpCodes.Error_ACCOUNT_DISABLED)
    ) {
      if (
        error.data.response.code ===
          PbHttpCodes.Error_USER_LOGGED_OUT_ALREADY ||
        error.data.response.code === PbHttpCodes.Error_UNABLE_TO_AUTHENTICATE ||
        error.data.response.code === PbHttpCodes.Error_ACCOUNT_DISABLED
      ) {
        if (AlertService.alertModal) {
          AlertService.alertModal.alert(
            localization[getLocale()].ERROR.toUpperCase(),
            localization[getLocale()]['ERROR_CODE' + error.data.response.code],
            [
              {
                text: localization[getLocale()].OK,
                onPress: () => {
                  store.dispatch(logoutRequested());
                },
                style: 'cancel',
              },
            ],
          );
        }
      }
      setSessionExpired(true);

      // showErrorAlert(localization[getLocale()].ERROR_CODE_00062, [
      //   {
      //     text: localization[getLocale()].OK,
      //     onPress: () => {
      //       navigationService.replaceRoute('auth');
      //       setSessionExpired(false);
      //     },
      //     style: 'cancel',
      //   },
      // ]);
    } else {
      return false;
    }
  } else {
    return false;
  }
}
